import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { TreeleafStorage } from "@anydone/treeleaf_js_utils";

// TreeleafStorage.acceptQueriesFromRemote([
//     "https://app.anydone.com",
//     "https://inbox.anydone.net",
//     "https://app.anydone.net",
//     "http://localhost:4500",
//     "http://localhost:3000",
// ]);

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
